import React, { Suspense } from 'react'

import { CardsList } from './parts/CardsList'
import { ListSkeleton } from '@/components/ListSkeleton'
import ErrorPage from '@/pages/Error'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { Divider, Skeleton, Stack } from '@mui/material'
import { CreditCardsTabHeader } from './parts/CreditCardsTabHeader'

const CardsTab: React.FC = () => {
  return (
    <ErrorBoundary fallback={<ErrorPage />}>
      <Suspense
        fallback={
          <Stack direction="column" width="100%" spacing={2}>
            <Stack direction="row" justifyContent="space-between" width="100%" spacing={2}>
              <Skeleton variant="rounded" width="50%" height="2.5rem" sx={{ borderRadius: 2 }} />
              <Skeleton variant="rounded" width="50%" height="2.5rem" sx={{ borderRadius: 4 }} />
            </Stack>
            <Divider sx={{ my: 1 }} />
            <ListSkeleton.Wrapper>
              <ListSkeleton.Rectangle height="5rem" />
            </ListSkeleton.Wrapper>
          </Stack>
        }
      >
        <Stack direction="column" width="100%" spacing={2}>
          <CreditCardsTabHeader />
          <Divider sx={{ my: 1 }} />
          <CardsList />
        </Stack>
      </Suspense>
    </ErrorBoundary>
  )
}

export default CardsTab
